<template>
  <div>
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'AccordionGroup',
    mounted() {
      this.$on('expanded-accordion', this.expandedAccordion);
    },
    methods: {
      expandedAccordion(id) {
        this.$emit(
          'expanded-child-accordion',
          id
        );
      }
    }
  };
</script>
